document.addEventListener("DOMContentLoaded", function () {
  // ============================================================

  // =========================== FIRST ACTIVE BUNDLE

  // ============================================================

  let variantData = document.querySelector("script[data-variant-json]");
  let metafieldsData = document.querySelector("script[data-meta-json]");
  let variantId = null;

  if (variantData && metafieldsData) {
    try {
      variantData = JSON.parse(variantData.innerHTML);
    } catch (error) {
      console.error("Error parsing variantData:", error);
    }
    try {
      metafieldsData = JSON.parse(metafieldsData.innerHTML);
    } catch (error) {
      console.error("Error parsing metafieldsData:", error);
    }

    console.log("variantData:", variantData);
    console.log("metafieldsData:", metafieldsData);

    let price_adjustment = parseFloat(
      variantData.first_variant_price_adjustment
    );
    console.log("price_adjustment:", price_adjustment);
    const bundleButtons = document.querySelectorAll(".bundle-button");
    const overlay = document.getElementById("popup-overlay");
    const closePopupButtons = document.querySelectorAll(".close-popup-button");

    // Function to close the popup and hide the overlay
    function closePopup() {
      // Hide all bundle popups
      const allBundlePopups = document.querySelectorAll(".bundle-popup");
      allBundlePopups.forEach((popup) => {
        popup.style.transform = "translateX(100%)";
      });

      // Hide the overlay
      overlay.style.display = "none";

      // Reset the display of bundle content with class "bundle-product-variants"
      const allBundleContent = document.querySelectorAll(
        ".bundle-product-variants"
      );
      allBundleContent.forEach((content) => {
        content.style.display = "none";
      });

      // Enable scrolling on the body
      document.body.style.overflow = "auto";
    }

    // Add click event listeners to bundle buttons to open the corresponding bundle popup
    bundleButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const bundleVariant = this.getAttribute("data-bundle-variant");
        const loopIndex = this.getAttribute("data-loop-index");

        // Select the corresponding bundle popup
        const selectedbundlePopup = document.querySelector(
          `.bundle-popup[data-bundle-variant-popup="${bundleVariant}"]`
        );

        // Check if bundlePopup exists
        if (selectedbundlePopup) {
          // Reset all bundle popups first
          const allBundlePopups = document.querySelectorAll(".bundle-popup");
          allBundlePopups.forEach((popup) => {
            popup.style.transform = "translateX(100%)";
          });

          // Reset overlay
          overlay.style.display = "none";

          // Get the selectedbundlePopupinner inside the open popup
          const selectedbundlePopupinner = selectedbundlePopup.querySelector(
            `.bundle-product-variants[data-loop-id="${loopIndex}"]`
          );

          // Apply styles to the active selectedbundlePopup, selectedbundlePopupinner, and overlay
          selectedbundlePopupinner.style.display = "block";
          selectedbundlePopup.style.display = "block";
          selectedbundlePopup.style.transform = "translateX(0%)";
          overlay.style.display = "block";

          // Disable scrolling on the body
          document.body.style.overflow = "hidden";
        }
      });
    });

    // Add a click event listener to the overlay to close the popup
    overlay.addEventListener("click", function (event) {
      // Check if the click event target is the overlay itself (not its children)
      if (event.target === overlay) {
        closePopup();
      }
    });

    // Add a click event listener to each close button
    closePopupButtons.forEach((button) => {
      button.addEventListener("click", function () {
        closePopup();
      });
    });

    // When select-bundle-variant is clicked, update the content of the matching .bundle-products-list
    const selectBundleVariant = document.querySelectorAll(
      ".select-bundle-variant"
    );

    selectBundleVariant.forEach((selectBundleVariant) => {
      selectBundleVariant.addEventListener("click", function () {
        const popupTitle = this.getAttribute("data-popup-title");
        const popupImage = this.getAttribute("data-popup-image");
        const popupPrice = parseFloat(this.getAttribute("data-popup-price"));
        const popupId = parseFloat(this.getAttribute("data-popup-variant-id"));

        const popupInventory = parseFloat(this.getAttribute("data-variant-qty")); 
        const popupBeforePrice = parseFloat(this.getAttribute("data-popup-before-price"));

        // Get the data-loop-id attribute value of the clicked select-bundle-variant
        const loopId = this.closest(".bundle-product-variants").getAttribute(
          "data-loop-id"
        );

        // Find the corresponding .bundle-products-list using the loopId
        const bundleProductList = document.querySelector(
          `.bundle-products-list[data-loop-index="${loopId}"]`
        );

        if (bundleProductList) {
          const titleElement = bundleProductList.querySelector(
            ".bundle-list .variant-title"
          );
          const imageElement = bundleProductList.querySelector(
            ".bundle-list .active-bundle-image"
          );
        
          // Update the title and image based on the clicked variant's data
          titleElement.textContent = popupTitle;
          imageElement.src = popupImage;

          // Update the data-variant-id attribute of the bundle product list and the price
          bundleProductList.setAttribute("data-variant-id", popupId);
          bundleProductList.setAttribute("data-variant-price", popupPrice);
          bundleProductList.setAttribute("data-variant-qty", popupInventory);
          bundleProductList.classList.remove("out-of-stock");
          bundleProductList.setAttribute("data-variant-before-price", popupBeforePrice);
          let notAvailableImage = bundleProductList.querySelector(".not_avaliable");

          // Remove the .not_avaliable image if it exists
          if (notAvailableImage) {
            notAvailableImage.parentNode.removeChild(notAvailableImage);
          }
        }
        
        calculateAndSetTotalPrice(price_adjustment);
        closePopup(); 
        checkOutOfStock();

        

      });
    });

    function checkOutOfStock() {
      // Find all .bundle-products-list elements that have the out-of-stock class
      const outOfStockLists = document.querySelectorAll(".bundle-products-list.out-of-stock");

      // Get the #bundle-add-to-cart element
      const addToCartButton = document.getElementById("bundle-add-to-cart");

      if (outOfStockLists.length > 0) {
        // If there are any .bundle-products-list elements that have the out-of-stock class, add the out-of-stock class to the #bundle-add-to-cart element
        addToCartButton.classList.add("out-of-stock");
      } else {
        // Otherwise, remove the out-of-stock class from the #bundle-add-to-cart element
        addToCartButton.classList.remove("out-of-stock");
      }
    }
    checkOutOfStock();




    // ============================================================
    // =========================== ON VARIANT CHANGE
    // ============================================================
    document.addEventListener("on:variant:change", async (event) => {
        let selectedVariant = event.detail.variant;
        let selectedVariantId = selectedVariant.id;

    // Variant metafields


      if (metafieldsData.variantMetafields[selectedVariantId]) {
        let componentQuantities = metafieldsData.variantMetafields[selectedVariantId].metafields.component_quantities;
        let price_adjustment = parseFloat(metafieldsData.variantMetafields[selectedVariantId].metafields.price_adjustment);
        
        let bundleProductLists = document.querySelectorAll(".bundle-products-list");
        let inventoriesQty = Array.from(bundleProductLists).map(bundleProductList => parseInt(bundleProductList.getAttribute("data-variant-qty")));
    

        console.log('inventoriesQty:', inventoriesQty);
        console.log("componentQuantities:", componentQuantities);
    
        console.log("selectedVariantId before update:", selectedVariantId); 

        updateImageBasedOnVariant(selectedVariantId, metafieldsData);
        
        // Update the data-product-qty attribute
        await updateProductQty(componentQuantities, selectedVariantId);
    
        // Iterate over each bundle product list
        for (let i = 0; i < bundleProductLists.length; i++) {
          let bundleProductList = bundleProductLists[i];
          let currentImage = bundleProductList.querySelector("img");
          let newImage = bundleProductList.querySelector("img[src='https://cdn.shopify.com/s/files/1/0778/7728/1075/files/no-image.svg?v=1702466454']");
          let variantTitle = bundleProductList.querySelector(".variant-title");

          if (componentQuantities[i] > inventoriesQty[i]) {
            bundleProductList.classList.add("out-of-stock");
    
            if (!variantTitle.textContent.includes(" - Udsolgt")) {
              variantTitle.textContent += " - Udsolgt";
            }
    
            if (!newImage) {
              newImage = document.createElement("img");
              newImage.src = "https://cdn.shopify.com/s/files/1/0778/7728/1075/files/no-image.svg?v=1702466454";
              newImage.classList.add("not_avaliable");
              currentImage.parentNode.insertBefore(newImage, currentImage);
            }
          } else {
            bundleProductList.classList.remove("out-of-stock");
            variantTitle.textContent = variantTitle.textContent.replace(" - Udsolgt", "");
    
            if (newImage) {
              newImage.parentNode.removeChild(newImage);
            }
          }
        }
    
 
    
        calculateAndSetTotalPrice(price_adjustment);
        checkOutOfStock();
      }
    });
    

    async function updateImageBasedOnVariant(selectedVariantId, metafieldsData) {
      // Update image based on the selected variant's featured image
      const imageElement = document.querySelector(".active-bundle-image");
      // Check if the variant data for the selected variant exists
      if (metafieldsData.variantMetafields[selectedVariantId] && metafieldsData.variantMetafields[selectedVariantId].variant[0]) {
        let imageSrc = `https:${metafieldsData.variantMetafields[selectedVariantId].variant[0].featured_image.src}`;
        let variantOptionTitle = metafieldsData.variantMetafields[selectedVariantId].variant[0].option1;
        
       
        if (imageSrc) {
          console.log("selectedVariantId:", selectedVariantId);
          
          console.log("variant_data:", imageSrc);
          if (imageSrc) {
            imageElement.src = imageSrc;
          }
        }

        if (variantOptionTitle) {
          const variantTitleElement = document.querySelector(".variant-title");
          variantTitleElement.textContent = variantOptionTitle;
        }
        
      } else {
        console.log('Variant data not available for selected variant');
      }

    }

    // Function to update the data-product-qty attribute and data-bundle-variant attribute
    // Function to update the data-product-qty attribute and data-bundle-variant attribute
    async function updateProductQty(componentQuantities, selectedVariantId) {
      const bundleProductLists = document.querySelectorAll(".bundle-products-list");
      const bundlePopups = document.querySelectorAll(".bundle-product-variants");
    
      bundleProductLists.forEach((bundleProductList, bundleIndex) => {
        let qty = "N/A"; // Declare bundleQty here
    
        // Ensure the variant ID exists before setting the attribute
        if (metafieldsData.variantMetafields[selectedVariantId] && 
            metafieldsData.variantMetafields[selectedVariantId].variant[bundleIndex]) {
          bundleProductList.setAttribute(
            "data-variant-id",
            metafieldsData.variantMetafields[selectedVariantId].variant[bundleIndex].id
          );
        } else {
          console.error('Variant ID not found for bundleIndex:', bundleIndex);
        }
    
        if (componentQuantities && componentQuantities.length > bundleIndex) {
          qty = componentQuantities[bundleIndex];
        }
    
        // Ensure the bundleQty element exists before setting textContent
        const bundleQty = bundleProductList.querySelector(".bundle-qty p");
        if (bundleQty) {
          bundleQty.textContent = qty;
        } else {
          console.error('bundleQty element not found for bundleIndex:', bundleIndex);
        }
    
        bundleProductList.setAttribute("data-active-qty", qty);
        bundleProductList.setAttribute("data-bundle-variant", selectedVariantId);
    
        // set data-bundle-variant for buttons inside bundleProductList
        const bundleButtons = bundleProductList.querySelectorAll(".bundle-button");
        bundleButtons.forEach((bundleButton) => {
          bundleButton.setAttribute("data-bundle-variant", selectedVariantId);
        });
    
        const correspondingBundlePopup = bundlePopups[bundleIndex];
        if (correspondingBundlePopup) {
          correspondingBundlePopup.setAttribute("data-product-qty", qty);
        } else {
          console.error('correspondingBundlePopup element not found for bundleIndex:', bundleIndex);
        }
      });
    }

    function calculateAndSetTotalPrice(discountAmount) {
      let totalValue = 0;
      let totalBeforeDiscount = 0; // Initialize total before discount value
      let currencyElement = document.getElementById("currency");
      let currency = currencyElement.getAttribute("data-currency");
      if (currency === "DKK") currency = "kr.";
      let currencySymbol = currencyElement.getAttribute("data-currency-symbol");
      console.log("The active currency is: " + currency);
      document.querySelectorAll(".bundle-products-list").forEach((bundleProduct) => {
        // Get the current price and quantity
        const variantPrice = parseFloat(bundleProduct.getAttribute("data-variant-price").replace(",", "."));
        const activeQty = parseInt(bundleProduct.getAttribute("data-active-qty"));
    
        // Calculate the current total value
        const productValue = variantPrice * activeQty;
        totalValue += productValue;
    
        // Assuming you meant to add a new attribute for the before discount price
        const variantBeforePrice = parseFloat(bundleProduct.getAttribute("data-variant-before-price").replace(",", "."));
        const beforeDiscountValue = variantBeforePrice * activeQty; // Calculate the before discount value
        totalBeforeDiscount += beforeDiscountValue; // Add to the total before discount value
      });
    
      // Format the totals with a comma as the decimal separator
      const formattedTotalValue = totalValue.toFixed(2).replace(".", ",");
      const formattedTotalBeforeDiscount = totalBeforeDiscount.toFixed(2).replace(".", ",");
    
      let discountedPrice = formattedTotalValue; // Initialize with total value for cases without discount
    
      // Check if discountAmount is a valid number and calculate the new price with the discount
      if (!isNaN(discountAmount)) {
        discountedPrice = (
          parseFloat(formattedTotalValue.replace(",", ".")) -
          parseFloat(formattedTotalValue.replace(",", ".")) * discountAmount / 100
        ).toFixed(2).replace(".", ",");
      }
    
      // Update the product info price
      const productInfoPrice = document.querySelector(".product-info__price strong");
      if (productInfoPrice) {
        if (currencySymbol.length === 1) {
          productInfoPrice.textContent = currencySymbol + discountedPrice + " " + currency;
        } else {
          productInfoPrice.textContent = discountedPrice + " " + currency;
        }
      }

      // Update the original price before discount, now using .bundle_before_price
      const bundleBeforePriceElement = document.querySelector(".bundle_before_price");
      if (bundleBeforePriceElement) {
        if (currencySymbol.length === 1) {
          bundleBeforePriceElement.textContent = currencySymbol + formattedTotalBeforeDiscount + " " + currency;
        } else {
          bundleBeforePriceElement.textContent = formattedTotalBeforeDiscount + " " + currency;
        }
      }
    }


// ============================================================
// =========================== AJAX ADD TO CART
// ============================================================

// Attach a click event handler to the button with id "add-to-cart-button"
document
.getElementById("bundle-add-to-cart")
.addEventListener("click", function (e) {
  // Get all elements with class "bundle-products-list"
  let bundleProducts = document.querySelectorAll(".bundle-products-list");
  
  const bundlePDF = document.getElementById("patternpdf"); 
  let bundlePDFurl = bundlePDF.getAttribute("custom-pattern-url"); 

  // Custom by Graphie
  let dataToSend = []; // Initialize an array to store the data for each product
  let productTitle = document.querySelector(".product-title").textContent;

  let metafieldsData = document.querySelector("script[data-meta-json]");
  metafieldsData = JSON.parse(metafieldsData.innerHTML);
  console.log("metafieldsData:", metafieldsData);

  bundleProducts.forEach(function (bundleProduct, index) {
    // Get the data attributes for variant ID, active quantity, and bundle variant
    let variantId = bundleProduct.getAttribute("data-variant-id");
    let bundleVariant = bundleProduct.getAttribute("data-bundle-variant");

    let activeQty = bundleProduct.getAttribute("data-active-qty");

    const metafieldsForBundle =
      metafieldsData.variantMetafields[bundleVariant];

    const discount = metafieldsForBundle.metafields.price_adjustment
      ? metafieldsForBundle.metafields.price_adjustment
      : 0;

    // Generate a random number for _customID
    const randomCustomID = Math.floor(Math.random() * 1000000);
  
    const data = {
      id: variantId,
      quantity: activeQty,
      properties: {
        _bundleVariantId: bundleVariant,
        _customID: randomCustomID,
        _bundleQuantity: JSON.stringify(
          metafieldsForBundle.metafields.component_quantities
        ),
        _bundlePatternPDF: bundlePDFurl,
        _bundleDiscount: discount,
        
      },
    };

    if (discount > 0) {
      data.properties.Discount = "-" + discount + "%";
    }

    // Push the data for each product to the array
    dataToSend.push(data);
  });

  // Call addItemToCart function with the array of data
  addItemToCart(dataToSend);
});

function addItemToCart(dataArray) {
  // Send the array of data in the request body
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items: dataArray, // Wrap the array in an object with a key "items"
    }),
  })
    .then(function (response) {
      if (response.ok) {
        // Refresh the cart drawer contents before opening it
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
          bubbles: true
        }));
        
        // Open the cart drawer instead of redirecting to the cart page
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
          detail: {
            opener: document.getElementById("bundle-add-to-cart") // Optional: specify the element to focus on when the drawer is closed
          }
        }));
      } else {
        // If the response is not ok, return the response text
        return response.text();
      }
    })
    .then(function (text) {
      // If the response was not ok, text will be defined
      if (text) {
        // Parse the text to JSON and throw an error with the parsed message
        let parsedMessage = JSON.parse(text);
        throw new Error(parsedMessage.description);
      }
    })
    .catch(function (error) {
      // Handle error
      // Your existing error handling code
    });
}

  }
});
    
    



